const API_BASE_URL = API_URL || ''

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

  if (!response.ok) {
    let message = response.statusText
    try {
      const payload = await response.json()
      message = payload.detail?.message || payload.message || message
    } catch {
      // Keep the HTTP status text when the backend returns no JSON body.
    }
    throw new Error(message)
  }

  return response.json()
}

export function startSession() {
  return request('/api/sessions', { method: 'POST' })
}

export function submitAnswer(sessionToken, questionId, value) {
  return request(`/api/sessions/${sessionToken}/answers`, {
    method: 'POST',
    body: JSON.stringify({ questionId, value }),
  })
}

export function goBack(sessionToken) {
  return request(`/api/sessions/${sessionToken}/back`, { method: 'POST' })
}

export function getReport(sessionToken) {
  return request(`/api/reports/${sessionToken}`)
}

export function getReportPdfUrl(sessionToken) {
  return `${API_BASE_URL}/api/reports/${sessionToken}/pdf`
}
